var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useCallback } from "react";
import { useFormContext } from "react-hook-form";
import { faExclamationCircle } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Checkbox from "syf-component-library/ui/atoms/Checkbox";
import { useEditProfileContext } from "../../../../../context/editProfileContext";
import { RowInput } from "../../../../subcomponents";
import getTranslation from "../../../../../strings/getTranslations";
var toggleAccountStatus = function (accountId, accounts) {
    if (accounts.includes(accountId)) {
        return accounts.filter(function (currentId) { return currentId !== accountId; });
    }
    return __spreadArray(__spreadArray([], accounts, true), [accountId], false);
};
var AccountsList = function () {
    var t = getTranslation().t;
    var _a = useEditProfileContext(), selectedAccountOption = _a.selectedAccountOption, accountsList = _a.accountsList, selectedAccounts = _a.selectedAccounts, updateSelectedAccounts = _a.updateSelectedAccounts, accountsWithErrors = _a.accountsWithErrors, updateAccountsWithErrors = _a.updateAccountsWithErrors;
    var isSubmitting = useFormContext().formState.isSubmitting;
    var selectedAccountId = selectedAccountOption.value;
    var handleOnChangeFactory = useCallback(function (account) {
        var cipherAccountId = account.info["cipher.accountId"];
        return function () {
            updateSelectedAccounts(toggleAccountStatus(cipherAccountId, selectedAccounts));
            updateAccountsWithErrors(accountsWithErrors.filter(function (accountWithErrors) { return accountWithErrors !== cipherAccountId; }));
        };
    }, [
        accountsWithErrors,
        selectedAccounts,
        updateAccountsWithErrors,
        updateSelectedAccounts,
    ]);
    if (accountsList && accountsList.length <= 0) {
        return null;
    }
    return (_jsx(_Fragment, { children: accountsList.map(function (account) {
            var accountId = account.info["cipher.accountId"];
            var accountError = accountsWithErrors.find(function (accountWithError) { return accountWithError === accountId; });
            if (accountId !== selectedAccountId) {
                return (_jsx(RowInput, { children: _jsxs(Checkbox, __assign({ onChange: handleOnChangeFactory(account), isChecked: selectedAccounts.includes(accountId), errorIcon: _jsx(FontAwesomeIcon, { icon: faExclamationCircle }), isDisabled: isSubmitting, error: accountError ? t("forms.errors.page.api") : undefined }, { children: [account.product.displayName, " ", account.info.accountLast4] })) }, accountId));
            }
            return null;
        }) }));
};
export default AccountsList;
